import { Alert, Group, Loader, Select, Stack } from '@mantine/core'
import { IconAlertCircle } from '@tabler/icons-react'
import { useState } from 'react'
import { useDevices } from '../api/devices'
import Gtsri from '../forms/Gtsri'

export default function DeviceConfigurator() {
  const [selectedDevice, setSelectedDevice] = useState<string | null>(null)
  const [selectedConfigurationType, setSelectedConfigurationType] = useState<
    string | null
  >(null)
  const [selectedDeliveryMethod, setSelectedDeliveryMethod] = useState<
    string | null
  >('network')
  const {
    data: devices,
    isPending,
    isError: devicesError,
    error,
  } = useDevices()

  const configurations = [
    {
      value: 'GTSRI',
      label: 'Backend Server Registration Information',
    },
  ]
  const deliveryMethods = [
    {
      value: 'network',
      label: 'Network',
    },
    {
      value: 'sms',
      label: 'SMS',
    },
  ]

  if (isPending) {
    return (
      <Stack align="center" justify="center" maw="100%">
        <Loader />
      </Stack>
    )
  }

  if (devicesError) {
    return (
      <Stack align="center" justify="center" maw="100%" w="100%">
        <Alert icon={<IconAlertCircle size="1rem" />} title="Error" color="red">
          {error.message}
        </Alert>
      </Stack>
    )
  }

  return (
    <Stack>
      <div
        style={{
          boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px',
          padding: '10px 75px',
        }}
      >
        <Group>
          <Select
            data={devices.map((device) => ({
              value: device.imei,
              label: `${device.imei} (${device.name})`,
            }))}
            value={selectedDevice}
            onChange={setSelectedDevice}
            label="Select Quecklink device"
            placeholder="Select device"
            searchable
            clearable
            maw={250}
            miw={150}
            w="full"
          />
          <Select
            data={configurations}
            value={selectedConfigurationType}
            onChange={setSelectedConfigurationType}
            label="Select configuration type"
            placeholder="Select type"
            searchable
            clearable
            maw={250}
            miw={150}
            w="full"
          />
          <Select
            data={deliveryMethods}
            value={selectedDeliveryMethod}
            onChange={setSelectedDeliveryMethod}
            label="Select delivery method"
            placeholder="Select delivery method"
            maw={250}
            miw={150}
            w="full"
          />
        </Group>
        <Group style={{ padding: '10px 0px' }}>
          {selectedDevice && selectedConfigurationType === 'GTSRI' && (
            <Gtsri
              imei={selectedDevice}
              delivery_method={selectedDeliveryMethod}
            />
          )}
        </Group>
      </div>
    </Stack>
  )
}
